import AutosaveSuccess from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Divider, FormControlLabel } from "@mui/material";
import { get, includes, toLower } from "lodash";
import React, { useEffect, useState } from "react";
import DealComplianceModal from "../../../common/js/components/DealComplianceModal";
import Comments from "../comments/CommentsContainer";
import CompCommentBlock from "../comments/CompCommentBlock";
import comments_constants from "../comments/constants";
import ListingCommentBlock from "../comments/ListingCommentBlock";
import { comp_contact_options } from "../contact/constants";
import ContactContainer from "../contact/ContactContainer";
import {
    lease_comp_contact_type_options,
    lease_invoice_contact_type_options,
    sale_invoice_contact_type_options,
} from "../deal/constants";
import DealForm from "../deal/DealForm";
import Installments from "../deal/Installments";
import InvoiceDetail from "../deal/InvoiceDetail";
import TotalConsiderationForm from "../deal/TotalConsiderationForm";
import DocumentDrop from "../documents/DocumentDropContainer";
import FinancialInformation from "../listing/FinancialInformation";
import ListingForm from "../listing/ListingForm";
import CondoForm from "../property/CondoForm";
import EducationalForm from "../property/EducationalForm";
import HospitalityForm from "../property/HospitalityForm";
import IndustrialForm from "../property/IndustrialForm";
import LandForm from "../property/LandForm";
import MixedUseForm from "../property/MixedUseForm";
import MultifamilyForm from "../property/MultifamilyForm";
import ParkingInfoForm from "../property/ParkingInfoForm";
import PortfolioForm from "../property/PortfolioForm";
import Property from "../property/Property";
import PropertyUpdateModalContainer from "../property/PropertyUpdateModalContainer";
import ReligiousForm from "../property/ReligiousForm";
import RetailForm from "../property/RetailForm";
import "./CompComponent.css";
import LeaseDetailForm from "./LeaseDetailForm";

const CompComponent = (props) => {
    const {
        deal,
        disableInputs,
        documentWarning,
        errors,
        handleAddArrayElement, // (path)
        handleAutocalculateTiSf,
        handleDeleteArrayElement,
        handleUpdateArrayElement,
        handleConfirmWarning,
        handleDocumentWarning,
        handleInput,
        handleObjectPropertyChange,
        id,
        listingAttributes,
        expandedErrorPanels,
        checkErrorPanels,
        restrictViewDocuments,
        toggleCheckErrorPanels,
        togglePropertySearchModal,
        toggleTerminationDoc,
        terminationDocument,
    } = props;

    const [panels, setPanels] = useState({
        listingFinancial:
            (get(deal, "listing.listingName") === null && get(deal, "fromListing", false) === true) ||
            includes(expandedErrorPanels, "listingFinancial"),
        listingInformation:
            (get(deal, "listing.listingName") === null && get(deal, "fromListing", false) === true) ||
            includes(expandedErrorPanels, "listingInformation"),
        property: includes(expandedErrorPanels, "property"),
    });

    useEffect(() => {
        if (checkErrorPanels === true) {
            let updatedPanels = {};
            if (includes(expandedErrorPanels, "property") && panels.property === false) {
                updatedPanels = { ...updatedPanels, property: true };
            }
            if (fromListing && includes(expandedErrorPanels, "listingInformation")) {
                updatedPanels = { ...updatedPanels, listingInformation: true };
            }
            if (fromListing && includes(expandedErrorPanels, "listingFinancial")) {
                updatedPanels = { ...updatedPanels, listingFinancial: true };
            }

            openGroupOfPanels(updatedPanels);
            toggleCheckErrorPanels(false);
        }
    }, [expandedErrorPanels]);

    const handleListingAttributeChange = (field, value) => {
        handleInput("listing.attributes." + field, value);
    };

    const handleListingChange = (field, value) => {
        handleInput("listing." + field, value);
        if (field === "autoRenewFlg" && value === true) {
            handleInput("listing.expirationDate", null);
        }
    };

    const togglePanel = (panel, open, checkErrorPanels) => {
        const updatedPanels = { ...panels };
        updatedPanels[panel] = open;
        setPanels(updatedPanels);
        if (checkErrorPanels) {
            toggleCheckErrorPanels(checkErrorPanels);
        }
    };

    const openGroupOfPanels = (updatedPanels) => {
        setPanels(updatedPanels);
    };

    const handleTriggerPropertySearchModal = (e) => {
        e.stopPropagation();
        togglePropertySearchModal(true);
    };

    const isLeaseComp = deal.transactionType.toLowerCase().includes("lease");

    const contactOptions = isLeaseComp
        ? [...lease_comp_contact_type_options, ...lease_invoice_contact_type_options]
        : sale_invoice_contact_type_options;

    const fromListing = get(deal, "fromListing", false);

    return (
        <div>
            <DocumentDrop
                entityKey={id}
                type="comp"
                documentTypes="comp"
                formDisabled={disableInputs}
                errors={errors.documents}
                restrictPreview={restrictViewDocuments}
                toggleTerminationDoc={toggleTerminationDoc}
                terminationDocument={terminationDocument}
                parentType="COMP"
                entityStatus={deal?.compStatus}
                stateCode={get(deal, "listing.property.primaryAddress.city.state.stateCode", null)}
            />
            {deal?.listing && (
                <div>
                    <Accordion
                        expanded={panels.property}
                        onChange={() => togglePanel("property", !panels.property, false)}
                    >
                        {(get(props.userProfile, "role") === "dataAdmin" &&
                            get(props.listing, "status") === "Active") ||
                        disableInputs === false ? (
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <div className="expansionPanelContentContainer">
                                    <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                                    <div>
                                        Property Information
                                        <EditIcon
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                fill: "#233a47",
                                                paddingLeft: "5px",
                                            }}
                                            onClick={(e) => handleTriggerPropertySearchModal(e)}
                                        />
                                        <div>
                                            <small className="entityIDText">
                                                Property ID: {get(deal, "listing.property.propertyKey")}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </AccordionSummary>
                        ) : (
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <div className="expansionPanelContentContainer">
                                    <AutosaveSuccess className="waterloo" />
                                    <div>
                                        Property Information
                                        <div>
                                            <small className="entityIDText">
                                                Property ID: {get(deal, "listing.property.propertyKey")}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </AccordionSummary>
                        )}
                        <Divider />
                        <AccordionDetails>
                            <Property
                                attributes={get(deal, "listing.property.propertyAttributes", {})}
                                property={get(deal, "listing.property", {})}
                                handleInputChange={(f, v) => handleInput("listing." + f, v)}
                                errors={errors}
                                handleAddArrayElement={(path) => props.handleAddArrayElement("listing." + path)}
                                handleDeleteArrayElement={(path, index) =>
                                    props.handleDeleteArrayElement("listing." + path, index)
                                }
                                handleUpdateArrayElement={(arrayPath, index, field, value) =>
                                    props.handleUpdateArrayElement("listing." + arrayPath, index, field, value)
                                }
                                deal={deal}
                                prefix="listing."
                                disableInputs={get(deal, "listing.property.propertyKey", null) !== null}
                                propertyType={
                                    get(deal, "listing.property.propertyType", null) !== null
                                        ? get(deal, "listing.property.propertyType", null)
                                        : get(deal, "propertyType", null)
                                }
                            />
                        </AccordionDetails>
                    </Accordion>
                    <div>
                        <PropertyUpdateModalContainer {...props} formType="comp" />
                    </div>
                </div>
            )}

            {/* Listing Information */}

            {deal?.listing && (
                <React.Fragment>
                    <Accordion
                        expanded={panels.listingInformation}
                        onChange={() => togglePanel("listingInformation", !panels.listingInformation, false)}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="expansionPanelContentContainer">
                                <AutosaveSuccess className="waterloo" />
                                <div>
                                    Listing Information {fromListing !== true ? "(Optional)" : ""}
                                    <div>
                                        <small className="entityIDText">LISTING ID: {deal.listing.listingKey}</small>
                                    </div>
                                </div>
                            </div>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <ListingForm
                                {...props}
                                disabled={disableInputs}
                                listing={get(deal, "listing", {})}
                                listingBrokers={get(deal, "listing.listingBrokers", [{}])}
                                propertyType={get(deal, "listing.attributes.useType", null)}
                                errors={get(errors, "listing", {})}
                                showListingExpiration={fromListing === true}
                                handleInputChange={(field, value) => handleInput(field, value)}
                                handleAddArrayElement={(path, obj) => handleAddArrayElement("listing." + path, obj)}
                                handleDeleteArrayElement={(path, index) => handleDeleteArrayElement(path, index)}
                                handleUpdateArrayElement={(path, index, field, value) =>
                                    handleUpdateArrayElement(path, index, field, value)
                                }
                                suppressRequired={!fromListing}
                                compStatus={get(deal, "compStatus", null)}
                            />
                            <Divider />
                            <MixedUseForm
                                {...props}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                data={listingAttributes}
                                dataPathPrefix="listing.attributes"
                                errors={get(errors, "attributes", {})}
                            />
                            <Divider />
                            <PortfolioForm
                                {...props}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                data={listingAttributes}
                                dataPathPrefix="listing.attributes"
                                errors={get(errors, "attributes", {})}
                            />
                            <Divider />
                            <CondoForm
                                {...props}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                data={listingAttributes}
                                dataPathPrefix="listing.attributes"
                                errors={get(errors, "attributes", {})}
                            />
                            <Divider />
                            <h3>Parking Information</h3>
                            <ParkingInfoForm
                                {...props}
                                context="listing"
                                data={listingAttributes}
                                onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                errors={get(errors, "listing.attributes", {})}
                            />
                            {toLower(deal.propertyType) === "industrial" && (
                                <div>
                                    <Divider />
                                    <h3>Industrial Information</h3>
                                    <IndustrialForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "land" && (
                                <div>
                                    <Divider />
                                    <h3>Land Information</h3>
                                    <LandForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "multifamily" && (
                                <div>
                                    <Divider />
                                    <h3>Multifamily Information</h3>
                                    <MultifamilyForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "retail" && (
                                <div>
                                    <Divider />
                                    <h3>Retail Information</h3>
                                    <RetailForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                        dataPathPrefix="listing.attributes"
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "hospitality" && (
                                <div>
                                    <Divider />
                                    <h3>Hospitality Information</h3>
                                    <HospitalityForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "religious" && (
                                <div>
                                    <Divider />
                                    <h3>Religious Information</h3>
                                    <ReligiousForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                        listingStatus={get(deal, "listing.status", null)}
                                        transactionType={deal.transactionType}
                                    />
                                </div>
                            )}
                            {toLower(deal.propertyType) === "educational" && (
                                <div>
                                    <Divider />
                                    <h3>Educational Information</h3>

                                    <EducationalForm
                                        {...props}
                                        context="listing"
                                        onChange={(field, value) => handleInput("listing.attributes." + field, value)}
                                        data={listingAttributes}
                                        errors={get(errors, "listing.attributes", {})}
                                    />
                                </div>
                            )}
                            <ListingCommentBlock
                                errors={errors}
                                handleInputChange={handleInput}
                                data={get(deal, "listing")}
                                disableInputs={true}
                                showFormTitle={true}
                            />
                        </AccordionDetails>
                    </Accordion>

                    {/*  Listing Contact Information  */}

                    {/* todo://hide contacts */}
                    {get(deal, "listing.attributes.contacts", []).length !== 0 ? (
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <div className="expansionPanelContentContainer">
                                    <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                                    <div>Listing Contact Information {fromListing !== true ? "(Optional)" : ""}</div>
                                </div>
                            </AccordionSummary>
                            <Divider />
                            <AccordionDetails>
                                <ContactContainer
                                    {...props}
                                    handleChange={() => null}
                                    handleAdd={() => handleAddArrayElement("listing.attributes.contacts")}
                                    handleDelete={(index) =>
                                        handleDeleteArrayElement("listing.attributes.contacts", index)
                                    }
                                    contacts={get(deal, "listing.attributes.contacts", [])}
                                    contactTypeOptions={contactOptions}
                                    addButtonText="Add Contact Information"
                                    includeInvoiceRecipientCheckbox={false}
                                    maxContacts={5}
                                    displayWhenEmpty={true}
                                    companyFieldAvailable={true}
                                    errors={errors}
                                    hideTitle={true}
                                />
                            </AccordionDetails>
                        </Accordion>
                    ) : null}

                    {/* Financial Information */}

                    <Accordion
                        expanded={panels.listingFinancial}
                        onChange={() => togglePanel("listingFinancial", !panels.listingFinancial, false)}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="expansionPanelContentContainer">
                                <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                                <div>Listing Financial Information {fromListing !== true ? "(Optional)" : ""}</div>
                            </div>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <FinancialInformation
                                {...props}
                                disableInputs={disableInputs}
                                suppressRequired={!fromListing}
                                listing={deal.listing}
                                errors={get(errors, "listing", {})}
                                handleInputChange={(field, value) => handleInput(field, value)}
                            />
                        </AccordionDetails>
                    </Accordion>
                </React.Fragment>
            )}

            {/* Comp Information */}

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div>
                        Comp Information
                        <div>
                            <small className="entityIDText">Deal ID: {deal.dealKey}</small>
                        </div>
                    </div>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    {!get(deal, "fromListing", true) ? (
                        <React.Fragment>
                            <div className="compComponentFlexContainer">
                                {!isLeaseComp && (
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={get(
                                                        deal,
                                                        "listing.attributes.investmentPropertyFlg",
                                                        false
                                                    )}
                                                    onChange={(e) =>
                                                        handleListingAttributeChange(
                                                            e.target.value,
                                                            !get(
                                                                deal,
                                                                "listing.attributes.investmentPropertyFlg",
                                                                false
                                                            )
                                                        )
                                                    }
                                                    value="investmentPropertyFlg"
                                                    disabled={disableInputs === true}
                                                    color="primary"
                                                />
                                            }
                                            label="Investment Property Sale"
                                        />
                                    </div>
                                )}
                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    get(deal, "listing.attributes.ownerOccupiedFlg", false)
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e, checked) =>
                                                    handleListingAttributeChange(e.target.value, checked)
                                                }
                                                value="ownerOccupiedFlg"
                                                disabled={disableInputs === true}
                                                color="primary"
                                            />
                                        }
                                        label="Owner Occupied"
                                    />
                                </div>
                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    get(deal, "listing.attributes.retailInvestmentNNNFlg", false)
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e, checked) =>
                                                    handleListingAttributeChange(e.target.value, checked)
                                                }
                                                value="retailInvestmentNNNFlg"
                                                disabled={disableInputs === true}
                                                color="primary"
                                            />
                                        }
                                        label="Retail Investment NNN"
                                    />
                                </div>

                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={get(deal, "listing.subleaseFlg", false) ? true : false}
                                                onChange={(e, checked) => handleListingChange(e.target.value, checked)}
                                                value="subleaseFlg"
                                                disabled={disableInputs === true}
                                                color="primary"
                                            />
                                        }
                                        label="Sublease"
                                    />
                                </div>
                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={get(deal, "listing.binswangerDealFlg", false) ? true : false}
                                                onChange={(e, checked) => handleListingChange(e.target.value, checked)}
                                                value="binswangerDealFlg"
                                                disabled={disableInputs === true}
                                                color="primary"
                                            />
                                        }
                                        label="Binswanger Deal"
                                    />
                                </div>
                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={get(deal, "listing.jdsDealFlg", false) ? true : false}
                                                onChange={(e, checked) => handleListingChange(e.target.value, checked)}
                                                value="jdsDealFlg"
                                                disabled={disableInputs === true}
                                                color="primary"
                                            />
                                        }
                                        label="JDS Deal"
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    ) : null}
                    <DealForm
                        {...props}
                        disableInputs={disableInputs}
                        transactionType={deal.transactionType}
                        handleInput={(field, value) => handleInput(field, value)}
                        errors={errors}
                    />
                </AccordionDetails>
            </Accordion>

            {/* Total Consideration */}

            {toLower(deal.transactionType) !== "sale" && (
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Total Consideration</AccordionSummary>
                    <Divider />
                    <AccordionDetails>
                        <TotalConsiderationForm
                            {...props}
                            disableInputs={disableInputs}
                            transactionType={deal.transactionType}
                            handleAutocalculateTiSf={handleAutocalculateTiSf}
                            handleTotalConsiderationAmountChange={(value) =>
                                handleInput("totalConsiderationAmount", value)
                            }
                        />
                        <InvoiceDetail {...props} disableInputs={disableInputs} />
                    </AccordionDetails>
                </Accordion>
            )}

            {/* Sale/Lease Details */}

            {toLower(deal.transactionType) === "lease" && (
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Lease Details</AccordionSummary>
                    <Divider />
                    {deal.transactionType && (
                        <AccordionDetails>
                            <LeaseDetailForm
                                {...props}
                                onChange={(event) => handleObjectPropertyChange("deal", event)}
                                leaseDetail={deal}
                                disableInputs={disableInputs}
                                transactionType={deal.transactionType}
                                useType={deal.propertyType}
                                errors={errors}
                                handleAutocalculateTiSf={handleAutocalculateTiSf}
                            />
                        </AccordionDetails>
                    )}
                </Accordion>
            )}

            {/* Installments */}

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Installment Schedule</AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <Installments
                        {...props}
                        installments={deal.installments}
                        handleAddArrayElement={props.handleAddArrayElement}
                        handleDeleteArrayElement={props.handleDeleteArrayElement}
                        handleUpdateArrayElement={props.handleUpdateArrayElement}
                        errors={errors}
                        disableInputs={disableInputs}
                        onlyEditCurrentInstallment={false}
                        preventAddSubtract={disableInputs}
                        displayFirstWhenEmpty={includes(["Draft", "Appraisal Draft"], get(deal, "dealStatus", null))}
                    />
                </AccordionDetails>
            </Accordion>

            {/* Comp Contact Information */}

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Comp Contact Information</AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <ContactContainer
                        {...props}
                        handleChange={(field, value, index) =>
                            handleInput(`propertyAttributes.contacts[${index}].${field}`, value)
                        } //todo
                        handleAdd={() => handleAddArrayElement("propertyAttributes.contacts")}
                        handleDelete={(index) => handleDeleteArrayElement("propertyAttributes.contacts", index)}
                        contacts={get(deal, "propertyAttributes.contacts", [])}
                        contactTypeOptions={comp_contact_options}
                        addButtonText="Add Contact Information"
                        includeInvoiceRecipientCheckbox={
                            !(
                                get(deal, "compStatus", null) === "Outside Draft" ||
                                get(deal, "compStatus", null) === "Outside"
                            )
                        }
                        maxContacts={5}
                        displayWhenEmpty={true}
                        companyFieldAvailable={true}
                        errors={errors}
                        hideTitle={true}
                        freeFormCompany={true}
                    />
                </AccordionDetails>
            </Accordion>

            <CompCommentBlock data={deal} disableInputs={disableInputs} handleInputChange={handleInput} />
            <Comments parentRecordType={comments_constants.COMP_PARENT_RECORD_TYPE} parentRecordId={id} />
            <DealComplianceModal
                documentWarning={documentWarning}
                handleDocumentWarning={handleDocumentWarning}
                handleConfirmWarning={handleConfirmWarning}
                documentTypeKey={"comp"}
            />
        </div>
    );
};

export default CompComponent;
